import styled from 'styled-components/macro';

export const DoneButton = styled.button`
  background-color: #44b1df;
  width: 16rem;
  border: 0 solid #787878;
  border-radius: 2.2rem;
  color: #ffffff;
  font-family: lato, sans-serif;
  font-size: 1.2rem;
  font-weight: 400;
  line-height: 1.3rem;
  padding: 0.8rem 2rem;
  margin-top: 25px;
  transition: 0.2s;

  &:hover {
    background-color: #545454;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  text-align: center;
  justify-content: center;
  align-items: center;
`;

export const Text = styled.div`
  color: #001758;
  font-family: 'Lato-Light', sans-serif;
  font-size: 2.5rem;
  font-weight: 300;
  line-height: 3.1rem;
`;

export const Graphic = styled.img`
  width: 50px;
  margin-bottom: 20px;
`;
